const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/agencies/$agencyId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { Link, createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/agencies/$agencyId")({
  beforeLoad: args => requirePermission(Permissions.Agencies.View, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});